export const projectArchitectures = {
    "query": {
        "title": "业务语义 → 受控分析 → 可核验结果",
        "mode": "已实现逻辑架构",
        "nodes": [
            {
                "id": "input",
                "label": "业务问题",
                "sub": "提问 · 澄清 · 时间范围",
                "kind": "entry",
                "detail": "业务输入先明确对象、指标口径与时间范围，复杂问题保留澄清和追问。",
                "x": 38,
                "y": 65
            },
            {
                "id": "semantic",
                "label": "业务语义层",
                "sub": "指标口径 · 标准问题",
                "kind": "data",
                "detail": "统一业务标准问题、指标语义与分析经验，使高频需求可复用。",
                "x": 350,
                "y": 65
            },
            {
                "id": "auth",
                "label": "权限与查询校验",
                "sub": "资产 · 字段 · 行级",
                "kind": "control",
                "detail": "执行前检查授权、只读约束、查询范围与结果规模；歧义和缺口进入澄清或拒答。",
                "x": 662,
                "y": 65
            },
            {
                "id": "orchestrator",
                "label": "分析编排",
                "sub": "推理与流程自动化",
                "kind": "compute",
                "detail": "按场景复杂度组织分析任务与工具调用，兼顾质量、响应和成本。",
                "x": 38,
                "y": 235
            },
            {
                "id": "query",
                "label": "受控查询服务",
                "sub": "模板 · 任务 · 结果",
                "kind": "compute",
                "detail": "将分析需求转化为可追踪任务，查询与会话解耦，保留执行依据。",
                "x": 350,
                "y": 235
            },
            {
                "id": "warehouse",
                "label": "数据供给与数仓协同",
                "sub": "Lattice · 既有分析服务",
                "kind": "data",
                "detail": "通过分析服务复用实时指标与分层加工数据，统一数据访问接口。",
                "x": 662,
                "y": 235
            },
            {
                "id": "answer",
                "label": "自助分析与主动预警",
                "sub": "业务使用 · 消息触达",
                "kind": "entry",
                "detail": "交付按需分析与异常通知两类服务，结果可留存和回看。",
                "x": 38,
                "y": 405
            },
            {
                "id": "record",
                "label": "分析记录与证据",
                "sub": "问题 · 口径 · 数据截止",
                "kind": "data",
                "detail": "关联原始问题、语义版本、执行记录与数据截止，支撑结果核验。",
                "x": 350,
                "y": 405
            },
            {
                "id": "feedback",
                "label": "业务验收与反馈复核",
                "sub": "10 题 · 标准题 ≥90%",
                "kind": "control",
                "detail": "以高频标准题检验分析结果，结合业务反馈持续改进问题定义与指标口径。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "业务入口与语义",
                "y": 30
            },
            {
                "label": "分析与数据服务",
                "y": 200
            },
            {
                "label": "交付与质量",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "input",
                "to": "semantic",
                "label": "明确口径"
            },
            {
                "from": "semantic",
                "to": "auth",
                "label": "授权校验",
                "kind": "control"
            },
            {
                "from": "input",
                "to": "orchestrator",
                "label": "分析任务"
            },
            {
                "from": "orchestrator",
                "to": "query",
                "label": "提交"
            },
            {
                "from": "auth",
                "to": "query",
                "label": "准入",
                "kind": "control"
            },
            {
                "from": "query",
                "to": "warehouse",
                "label": "查询"
            },
            {
                "from": "orchestrator",
                "to": "answer",
                "label": "交付"
            },
            {
                "from": "query",
                "to": "record",
                "label": "留存"
            },
            {
                "from": "answer",
                "to": "record",
                "label": "关联"
            },
            {
                "from": "record",
                "to": "feedback",
                "label": "复核"
            }
        ],
        "notes": [
            "业务语义、任务编排与数据服务分工明确。",
            "长查询与会话解耦，结果始终带口径与证据。"
        ]
    },
    "gamefactory": {
        "title": "从创意定义到可信游戏交付",
        "mode": "已实现逻辑架构",
        "nodes": [
            {
                "id": "idea",
                "label": "自然语言创意",
                "sub": "玩法 · 视觉 · 交互",
                "kind": "entry",
                "detail": "收敛开放需求为玩法定义、视觉方向与交互要求。",
                "x": 38,
                "y": 65
            },
            {
                "id": "spec",
                "label": "规则与质量定义",
                "sub": "版本 · 数值 · 公平性",
                "kind": "control",
                "detail": "统一规则、概率与金额边界，定义独立复核要求和阶段验收标准。",
                "x": 350,
                "y": 65
            },
            {
                "id": "model",
                "label": "模型与生图服务",
                "sub": "文本 · 视觉 · 素材",
                "kind": "external",
                "detail": "真实模型与生图参与内容生成，生成结果仍需验证。",
                "x": 662,
                "y": 65
            },
            {
                "id": "runtime",
                "label": "Rust 任务执行",
                "sub": "内嵌 Harness · 状态恢复",
                "kind": "compute",
                "detail": "任务执行体系统一管理阶段依赖、运行状态与异常恢复。",
                "x": 38,
                "y": 235
            },
            {
                "id": "generation",
                "label": "多模态生成与组装",
                "sub": "玩法 · 角色 · 场景 · UI",
                "kind": "compute",
                "detail": "协调视觉、素材和交互生成，组装可运行 H5 产物。",
                "x": 350,
                "y": 235
            },
            {
                "id": "gate",
                "label": "分阶段质量门禁",
                "sub": "规则 · 数值 · 运行验证",
                "kind": "control",
                "detail": "核对规则与实现一致性、产物版本和验证结果，失败项修复后复验。",
                "x": 662,
                "y": 235
            },
            {
                "id": "state",
                "label": "权威状态与规则",
                "sub": "恢复 · 重复操作控制",
                "kind": "data",
                "detail": "核心状态和结果决策与生成内容分离，保障运行过程一致。",
                "x": 38,
                "y": 405
            },
            {
                "id": "sandbox",
                "label": "生成内容运行隔离",
                "sub": "数据访问 · 外部通信",
                "kind": "control",
                "detail": "限制生成内容的数据访问、网络和结果权限；关键规则由受控执行域负责。",
                "x": 350,
                "y": 405
            },
            {
                "id": "artifact",
                "label": "H5 游戏与交付记录",
                "sub": "版本 · 制品 · 验证结果",
                "kind": "entry",
                "detail": "形成可追溯游戏包、移动交互与恢复验证记录，支撑后续玩法扩展。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "定义与约束",
                "y": 30
            },
            {
                "label": "生成与验证",
                "y": 200
            },
            {
                "label": "运行与交付",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "idea",
                "to": "spec",
                "label": "定义"
            },
            {
                "from": "idea",
                "to": "runtime",
                "label": "启动"
            },
            {
                "from": "spec",
                "to": "generation",
                "label": "约束",
                "kind": "control"
            },
            {
                "from": "model",
                "to": "generation",
                "label": "内容"
            },
            {
                "from": "runtime",
                "to": "generation",
                "label": "推进"
            },
            {
                "from": "generation",
                "to": "gate",
                "label": "校验"
            },
            {
                "from": "runtime",
                "to": "state",
                "label": "状态"
            },
            {
                "from": "generation",
                "to": "sandbox",
                "label": "运行"
            },
            {
                "from": "gate",
                "to": "artifact",
                "label": "准入",
                "kind": "control"
            },
            {
                "from": "state",
                "to": "sandbox",
                "label": "规则结果"
            },
            {
                "from": "sandbox",
                "to": "artifact",
                "label": "交付"
            }
        ],
        "notes": [
            "任务执行、核心规则与生成内容拥有不同权限边界。",
            "Rust 执行内核与内嵌 Harness 协同管理生成任务。"
        ]
    },
    "knowledge": {
        "title": "从企业资料到可追溯知识服务",
        "mode": "已实现逻辑架构",
        "nodes": [
            {
                "id": "sources",
                "label": "企业资料源",
                "sub": "知识库 · 文档 · 文件",
                "kind": "entry",
                "detail": "统一接入业务资料，保留来源、版本、结构和访问范围。",
                "x": 38,
                "y": 65
            },
            {
                "id": "assets",
                "label": "知识资产管理",
                "sub": "同步 · 版本 · 更新",
                "kind": "data",
                "detail": "处理资料变更与历史信息，维持可持续维护的知识资产。",
                "x": 350,
                "y": 65
            },
            {
                "id": "acl",
                "label": "授权与时效治理",
                "sub": "贯穿接入、检索与使用",
                "kind": "control",
                "detail": "权限过滤覆盖资料与检索环节，授权变化影响后续访问。",
                "x": 662,
                "y": 65
            },
            {
                "id": "compile",
                "label": "知识加工与编译",
                "sub": "结构 · 消歧 · 冲突",
                "kind": "compute",
                "detail": "整理复杂资料语义、同名对象和冲突，保留事实依据与更新关系。",
                "x": 38,
                "y": 235
            },
            {
                "id": "ontology",
                "label": "业务本体与关系",
                "sub": "术语 · 对象 · 约束",
                "kind": "data",
                "detail": "建立跨资料的业务对象、关系与语义模型，支持知识关联与查询理解。",
                "x": 350,
                "y": 235
            },
            {
                "id": "retrieval",
                "label": "混合检索与证据组织",
                "sub": "覆盖 · 前提 · 来源",
                "kind": "compute",
                "detail": "融合检索结果，控制冗余并组织足以支持结论的证据。",
                "x": 662,
                "y": 235
            },
            {
                "id": "inquiry",
                "label": "Agentic 调查",
                "sub": "多轮检索 · 核对 · 计算",
                "kind": "compute",
                "detail": "围绕证据缺口持续检索、关系追踪和交叉验证。",
                "x": 38,
                "y": 405
            },
            {
                "id": "answer",
                "label": "企业知识服务",
                "sub": "问答 · 规范 · 新人赋能",
                "kind": "entry",
                "detail": "面向集团内部业务线提供可追溯知识查询和复杂问题分析。",
                "x": 350,
                "y": 405
            },
            {
                "id": "evaluation",
                "label": "分层质量治理",
                "sub": "452 题 · 正确性 0.825",
                "kind": "control",
                "detail": "分别评估知识、检索、回答与运行质量，缺口和失效信息进入治理。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "知识输入与治理",
                "y": 30
            },
            {
                "label": "知识加工与检索",
                "y": 200
            },
            {
                "label": "应用与质量",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "sources",
                "to": "assets",
                "label": "接入"
            },
            {
                "from": "assets",
                "to": "acl",
                "label": "授权",
                "kind": "control"
            },
            {
                "from": "assets",
                "to": "compile",
                "label": "加工"
            },
            {
                "from": "compile",
                "to": "ontology",
                "label": "语义"
            },
            {
                "from": "ontology",
                "to": "retrieval",
                "label": "关联"
            },
            {
                "from": "acl",
                "to": "retrieval",
                "label": "过滤",
                "kind": "control"
            },
            {
                "from": "retrieval",
                "to": "inquiry",
                "label": "证据"
            },
            {
                "from": "inquiry",
                "to": "answer",
                "label": "结论"
            },
            {
                "from": "retrieval",
                "to": "answer",
                "label": "引用"
            },
            {
                "from": "answer",
                "to": "evaluation",
                "label": "评测"
            }
        ],
        "notes": [
            "权限与来源随知识流转，调查围绕真实证据推进。",
            "评测集正确性与线上任意问题准确率分开表达。"
        ]
    },
    "talent": {
        "title": "岗位建模、行为证据与人机协同评估",
        "mode": "产品流程与测评设计",
        "nodes": [
            {
                "id": "cv",
                "label": "候选人材料",
                "sub": "简历原文 · 经历线索",
                "kind": "entry",
                "detail": "保存原始材料与引用锚点，为岗位分析和面试准备提供经历线索。",
                "x": 38,
                "y": 65
            },
            {
                "id": "role",
                "label": "岗位胜任力模型",
                "sub": "JD · 行业经验 · 用人标准",
                "kind": "data",
                "detail": "融合 JD、岗位行业经验与用人标准，明确能力要求和可观察行为，支持岗位模板配置及同岗位共同标准。",
                "x": 350,
                "y": 65
            },
            {
                "id": "methods",
                "label": "行为与职业心理方法",
                "sub": "BEI · STAR · Topgrading",
                "kind": "control",
                "detail": "用行为事件访谈、STAR 和职业经历核查思路组织前期评估与出题；借鉴霍根关注的工作风格、动机与价值观、行为风险维度，设计岗位情境追问。",
                "x": 662,
                "y": 65
            },
            {
                "id": "parse",
                "label": "结构化经历与证据",
                "sub": "个人职责 · 行动 · 结果",
                "kind": "compute",
                "detail": "整理项目背景、个人职责、实际行动与结果；保留原文引用和信息缺口，区分个人贡献与团队成果。",
                "x": 38,
                "y": 235
            },
            {
                "id": "evaluation",
                "label": "岗位评估与横向对比",
                "sub": "价值点 · 风险线索 · 待验证",
                "kind": "compute",
                "detail": "结合岗位模板和行业经验形成岗位匹配分析，按共同评价标准进行横向对比，将优势与风险转为可验证问题。",
                "x": 350,
                "y": 235
            },
            {
                "id": "interview",
                "label": "面试准备与连续追问",
                "sub": "事件复盘 · 情境问题 · 分级",
                "kind": "compute",
                "detail": "围绕具体经历生成面试准备包和连续追问，跨经历核对贡献与能力表现；共同能力采用一致标准，问题按个人经历展开。",
                "x": 662,
                "y": 235
            },
            {
                "id": "review",
                "label": "面试验证与人工审核",
                "sub": "实际回答 · 现场观察 · 备注",
                "kind": "control",
                "detail": "由面试官核对具体经历、观察任务表现并记录备注，检查行为证据与评分依据，保留人工审核与最终决策。",
                "x": 38,
                "y": 405
            },
            {
                "id": "conclusion",
                "label": "匿名化面试后结论",
                "sub": "面试表现 · 面试官备注",
                "kind": "entry",
                "detail": "最终结论只使用匿名化面试表现与面试官备注，由面试官审核判断；与简历阶段的价值点和风险线索分别管理。",
                "x": 350,
                "y": 405
            },
            {
                "id": "quality",
                "label": "测评标准与质量校准",
                "sub": "引用支持 · 一致性 · 复核耗时",
                "kind": "control",
                "detail": "以共同能力维度和行为分级制定验收口径，关注信息遗漏、引用支持度、评分一致性及人工复核耗时，用于后续验收与人工校准。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "岗位标准与方法设计",
                "y": 30
            },
            {
                "label": "证据分析与面试准备",
                "y": 200
            },
            {
                "label": "行为验证、人工判断与质量校准",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "cv",
                "to": "parse",
                "label": "解析"
            },
            {
                "from": "role",
                "to": "evaluation",
                "label": "共同标准",
                "kind": "control"
            },
            {
                "from": "methods",
                "to": "evaluation",
                "label": "评估方法",
                "kind": "control"
            },
            {
                "from": "methods",
                "to": "interview",
                "label": "追问设计",
                "kind": "control"
            },
            {
                "from": "parse",
                "to": "evaluation",
                "label": "经历依据"
            },
            {
                "from": "evaluation",
                "to": "interview",
                "label": "验证问题"
            },
            {
                "from": "interview",
                "to": "review",
                "label": "回答与观察"
            },
            {
                "from": "review",
                "to": "conclusion",
                "label": "匿名化记录"
            },
            {
                "from": "quality",
                "to": "role",
                "label": "标准校准",
                "kind": "control"
            }
        ],
        "notes": [
            "同岗位采用共同评价标准，具体追问结合个人经历。",
            "职业心理维度用于岗位情境追问；质量指标用于验收设计与人工校准。"
        ]
    },
    "platform": {
        "title": "Agent 工程方法与共用能力体系",
        "mode": "平台能力关系图",
        "nodes": [
            {
                "id": "language",
                "label": "语言工程",
                "sub": "来源 · 语义 · 上下文",
                "kind": "control",
                "detail": "将语言视为模型、工具、知识与协作接口，约束来源、时效和读写范围。",
                "x": 38,
                "y": 65
            },
            {
                "id": "orchestration",
                "label": "任务编排",
                "sub": "状态 · 依赖 · 风险",
                "kind": "control",
                "detail": "按任务选择循环、DAG、状态机或事件方式，明确人员介入点。",
                "x": 350,
                "y": 65
            },
            {
                "id": "alignment",
                "label": "偏好对齐",
                "sub": "目标 · 评价 · 反馈",
                "kind": "control",
                "detail": "围绕业务目标定义验证标准，将反馈转为可复用行为约束。",
                "x": 662,
                "y": 65
            },
            {
                "id": "knowledge",
                "label": "知识与文件资产",
                "sub": "来源 · 权限 · 版本",
                "kind": "data",
                "detail": "统筹知识检索和文件资产，为任务提供可追溯资料。",
                "x": 38,
                "y": 235
            },
            {
                "id": "adk",
                "label": "Noesis ADK",
                "sub": "任务定义 · ContextPack",
                "kind": "compute",
                "detail": "确定性编排与业务执行分层，提供任务隔离、工具接口与运行记录。",
                "x": 350,
                "y": 235
            },
            {
                "id": "gateway",
                "label": "模型与业务工具",
                "sub": "接入 · 额度 · 观测",
                "kind": "external",
                "detail": "管理模型访问和业务工具边界，按真实负载做复用取舍。",
                "x": 662,
                "y": 235
            },
            {
                "id": "sop",
                "label": "r0-skill / AI-SOP",
                "sub": "阶段输入输出 · 门禁",
                "kind": "control",
                "detail": "需求澄清、系统理解、评审、实现验证、审查和提交归档拥有明确放行条件。",
                "x": 38,
                "y": 405
            },
            {
                "id": "products",
                "label": "业务 Agent 组合",
                "sub": "研发 · 日志 · 问数",
                "kind": "entry",
                "detail": "按具体场景逐项验证接入，而非宣称全部 Agent 已统一迁入。",
                "x": 350,
                "y": 405
            },
            {
                "id": "feedback",
                "label": "验收与经验资产",
                "sub": "失败案例 · 规则 · 指引",
                "kind": "data",
                "detail": "通过回归、评审和复盘沉淀团队知识及规则，支持持续交付。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "方法与技术判断",
                "y": 30
            },
            {
                "label": "共用工程能力",
                "y": 200
            },
            {
                "label": "研发交付与复盘",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "language",
                "to": "knowledge",
                "label": "组织原则"
            },
            {
                "from": "orchestration",
                "to": "adk",
                "label": "执行原则"
            },
            {
                "from": "alignment",
                "to": "sop",
                "label": "质量原则",
                "kind": "control"
            },
            {
                "from": "knowledge",
                "to": "adk",
                "label": "上下文"
            },
            {
                "from": "adk",
                "to": "gateway",
                "label": "工具"
            },
            {
                "from": "sop",
                "to": "products",
                "label": "门禁",
                "kind": "control"
            },
            {
                "from": "adk",
                "to": "products",
                "label": "工程基础"
            },
            {
                "from": "gateway",
                "to": "products",
                "label": "共用服务"
            },
            {
                "from": "products",
                "to": "feedback",
                "label": "业务反馈"
            }
        ],
        "notes": [
            "语言工程、任务编排与偏好对齐共同支撑公共能力和业务应用。",
            "研发 SOP 贯穿阶段职责、质量门禁与问题回流。"
        ]
    },
    "lattice": {
        "title": "可靠状态协调 × Rust 高性能计算",
        "mode": "已实现逻辑架构",
        "nodes": [
            {
                "id": "sources",
                "label": "业务源事件 / CDC",
                "sub": "状态变更 · 业务时间",
                "kind": "entry",
                "detail": "采集高频事件与订单变化，按统一事件标识、时间和版本组织数据。",
                "x": 38,
                "y": 65
            },
            {
                "id": "kafka",
                "label": "Kafka 可回放日志",
                "sub": "采集与计算解耦",
                "kind": "bus",
                "detail": "提供事件流与历史回放入口，支撑流处理和补算。",
                "x": 350,
                "y": 65
            },
            {
                "id": "dlq",
                "label": "异常隔离与观测",
                "sub": "坏数据 · 延迟 · 积压",
                "kind": "control",
                "detail": "分别观察业务和处理异常，保留异常样例及恢复依据。",
                "x": 662,
                "y": 65
            },
            {
                "id": "flink",
                "label": "Flink 状态协调",
                "sub": "窗口 · checkpoint · 恢复",
                "kind": "compute",
                "detail": "Flink 主作业持有状态并协调恢复、一致性和迟到事件修正。",
                "x": 38,
                "y": 235
            },
            {
                "id": "rust",
                "label": "Rust 计算算子",
                "sub": "Arrow 列式批量计算",
                "kind": "compute",
                "detail": "Rust 承担确定性批量计算，接收数据及所需状态，返回计算结果与变更。",
                "x": 350,
                "y": 235
            },
            {
                "id": "sink",
                "label": "结果提交与修正",
                "sub": "幂等 / 事务边界",
                "kind": "control",
                "detail": "按业务时间修正历史结果，协调计算、提交和重放边界。",
                "x": 662,
                "y": 235
            },
            {
                "id": "store",
                "label": "分层数据存储",
                "sub": "StarRocks · Paimon",
                "kind": "data",
                "detail": "保持实时与历史数据协同，按各自用途组织落库和联合分析。",
                "x": 38,
                "y": 405
            },
            {
                "id": "metrics",
                "label": "共用指标与分析服务",
                "sub": "业务口径 · 窗口 · 核验",
                "kind": "compute",
                "detail": "沉淀可复用指标与分析模型，支撑多场景并行使用。",
                "x": 350,
                "y": 405
            },
            {
                "id": "business",
                "label": "支付 / 获客 / 问数",
                "sub": "监控 · 预警 · 自助分析",
                "kind": "entry",
                "detail": "交付支付异常监控与获客转化分析；窗口大小不是数据时延承诺。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "采集与事件契约",
                "y": 30
            },
            {
                "label": "实时计算与一致性",
                "y": 200
            },
            {
                "label": "存储与业务应用",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "sources",
                "to": "kafka",
                "label": "事件"
            },
            {
                "from": "kafka",
                "to": "flink",
                "label": "消费"
            },
            {
                "from": "kafka",
                "to": "dlq",
                "label": "异常分流"
            },
            {
                "from": "flink",
                "to": "rust",
                "label": "批量计算"
            },
            {
                "from": "rust",
                "to": "sink",
                "label": "结果"
            },
            {
                "from": "flink",
                "to": "store",
                "label": "状态协调"
            },
            {
                "from": "sink",
                "to": "store",
                "label": "提交",
                "kind": "control"
            },
            {
                "from": "store",
                "to": "metrics",
                "label": "查询"
            },
            {
                "from": "metrics",
                "to": "business",
                "label": "服务"
            }
        ],
        "notes": [
            "Flink 负责状态、恢复与一致性协调；Rust 负责高性能计算。",
            "当前处理能力约 3.3 万条/秒；监控统计窗口与端到端数据时延分别计量。"
        ]
    },
    "bilm": {
        "title": "关系代数与多级持久化分层",
        "mode": "已实现逻辑架构",
        "nodes": [
            {
                "id": "request",
                "label": "关系查询 / 变更",
                "sub": "smallID ↔ largeID",
                "kind": "entry",
                "detail": "提供二元关系及其集合代数操作，服务推荐、风控和画像场景。",
                "x": 38,
                "y": 65
            },
            {
                "id": "bitmap",
                "label": "RoaringBitmap 主索引",
                "sub": "smallID → largeID",
                "kind": "data",
                "detail": "用集合包含判断支持反向查询，移除冗余 forward 索引。",
                "x": 350,
                "y": 65
            },
            {
                "id": "dirty",
                "label": "Dirty 变更集合",
                "sub": "增量范围 · 阈值",
                "kind": "data",
                "detail": "追踪变化集合，决定增量快照范围与回退条件。",
                "x": 662,
                "y": 65
            },
            {
                "id": "wal",
                "label": "WAL 先写",
                "sub": "CRC · 变更记录",
                "kind": "bus",
                "detail": "将写前日志和校验纳入更新顺序，异常后保留恢复依据。",
                "x": 38,
                "y": 235
            },
            {
                "id": "cut",
                "label": "一致性切点",
                "sub": "锁内切点 · 锁外 I/O",
                "kind": "compute",
                "detail": "冻结一致快照范围后在锁外完成 I/O，缩短写路径阻塞。",
                "x": 350,
                "y": 235
            },
            {
                "id": "snapshot",
                "label": "Snapshot + Delta",
                "sub": "原子落盘",
                "kind": "data",
                "detail": "完整与增量快照组合，降低频繁全量快照的资源压力。",
                "x": 662,
                "y": 235
            },
            {
                "id": "recovery",
                "label": "启动与异常恢复",
                "sub": "快照 + 日志回放",
                "kind": "compute",
                "detail": "按持久化层次恢复一致索引状态。",
                "x": 38,
                "y": 405
            },
            {
                "id": "service",
                "label": "关系索引服务",
                "sub": "查询结果 · 状态核对",
                "kind": "entry",
                "detail": "恢复后的状态回到同一关系查询接口。",
                "x": 350,
                "y": 405
            },
            {
                "id": "verify",
                "label": "规模验证",
                "sub": "3000 万 / 500",
                "kind": "control",
                "detail": "数字分别表示 largeID 与 smallID 验证规模，不是吞吐率。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "请求与索引",
                "y": 30
            },
            {
                "label": "可靠性与快照",
                "y": 200
            },
            {
                "label": "恢复与验证",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "request",
                "to": "wal",
                "label": "先写"
            },
            {
                "from": "wal",
                "to": "bitmap",
                "label": "更新"
            },
            {
                "from": "bitmap",
                "to": "dirty",
                "label": "标记"
            },
            {
                "from": "dirty",
                "to": "cut",
                "label": "快照范围"
            },
            {
                "from": "cut",
                "to": "snapshot",
                "label": "落盘"
            },
            {
                "from": "snapshot",
                "to": "recovery",
                "label": "加载"
            },
            {
                "from": "wal",
                "to": "recovery",
                "label": "回放"
            },
            {
                "from": "recovery",
                "to": "service",
                "label": "恢复"
            },
            {
                "from": "service",
                "to": "verify",
                "label": "核对"
            }
        ],
        "notes": [
            "日志先写、快照切点和锁外 I/O 拥有清晰顺序。"
        ]
    },
    "global-recommendation": {
        "title": "状态感知推荐与显式约束",
        "mode": "技术方案逻辑架构",
        "nodes": [
            {
                "id": "behavior",
                "label": "行为与聚合指标",
                "sub": "Session · 生命周期",
                "kind": "entry",
                "detail": "将用户行为序列与聚合指标用于状态理解。",
                "x": 38,
                "y": 65
            },
            {
                "id": "features",
                "label": "规则特征与价值分层",
                "sub": "行为 · 资金 · 状态",
                "kind": "compute",
                "detail": "先建立可解释规则分群，区分价值层与当前行为状态。",
                "x": 350,
                "y": 65
            },
            {
                "id": "cluster",
                "label": "聚类置信度校验",
                "sub": "K-Means / GMM",
                "kind": "compute",
                "detail": "用聚类检查规则分群的稳定性，而非替代业务口径。",
                "x": 662,
                "y": 65
            },
            {
                "id": "state",
                "label": "状态优先级",
                "sub": "生命周期与节奏保护",
                "kind": "control",
                "detail": "以当前状态决定策略切换和约束条件。",
                "x": 38,
                "y": 235
            },
            {
                "id": "rank",
                "label": "多目标排序",
                "sub": "匹配 · 新颖度 · 长期目标",
                "kind": "compute",
                "detail": "在不同状态下调整目标权重，避免单目标贪心。",
                "x": 350,
                "y": 235
            },
            {
                "id": "risk",
                "label": "风险估计与硬约束",
                "sub": "波动边界 · 可控输出",
                "kind": "control",
                "detail": "将显式风险限制纳入推荐输出，保护用户节奏。",
                "x": 662,
                "y": 235
            },
            {
                "id": "candidates",
                "label": "候选与策略编排",
                "sub": "推荐候选",
                "kind": "data",
                "detail": "将候选、圈层与策略规则组织为可审查输入。",
                "x": 38,
                "y": 405
            },
            {
                "id": "output",
                "label": "受约束推荐结果",
                "sub": "状态匹配 · 多样性",
                "kind": "entry",
                "detail": "输出满足当前状态与约束的推荐结果。",
                "x": 350,
                "y": 405
            },
            {
                "id": "feedback",
                "label": "行为反馈",
                "sub": "下一轮状态更新",
                "kind": "data",
                "detail": "后续行为用于状态与分群更新；未附加未经验证的经营提升。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "特征与分群",
                "y": 30
            },
            {
                "label": "策略与约束",
                "y": 200
            },
            {
                "label": "交付与反馈",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "behavior",
                "to": "features",
                "label": "特征"
            },
            {
                "from": "features",
                "to": "cluster",
                "label": "校验"
            },
            {
                "from": "features",
                "to": "state",
                "label": "状态"
            },
            {
                "from": "cluster",
                "to": "state",
                "label": "置信度"
            },
            {
                "from": "state",
                "to": "rank",
                "label": "策略"
            },
            {
                "from": "rank",
                "to": "risk",
                "label": "约束",
                "kind": "control"
            },
            {
                "from": "candidates",
                "to": "rank",
                "label": "候选"
            },
            {
                "from": "risk",
                "to": "output",
                "label": "放行",
                "kind": "control"
            },
            {
                "from": "output",
                "to": "feedback",
                "label": "反馈"
            }
        ],
        "notes": [
            "用户分群、多目标排序与业务硬约束分层协同。"
        ]
    },
    "kol": {
        "title": "多路召回与社交协同推荐",
        "mode": "已实现逻辑架构",
        "nodes": [
            {
                "id": "content",
                "label": "内容与达人画像",
                "sub": "内容 · 商单 · 品类",
                "kind": "data",
                "detail": "联合内容、画像、商单和品类组织语义特征。",
                "x": 38,
                "y": 65
            },
            {
                "id": "social",
                "label": "达人社交关系",
                "sub": "互动 · 亲近度",
                "kind": "data",
                "detail": "基于达人互动建立社交图，支持组合推荐。",
                "x": 350,
                "y": 65
            },
            {
                "id": "goals",
                "label": "营销目标与预算",
                "sub": "圈层 · 配额 · 约束",
                "kind": "entry",
                "detail": "以具体营销场景定义候选、预算与分发规则。",
                "x": 662,
                "y": 65
            },
            {
                "id": "recall",
                "label": "多链路语义召回",
                "sub": "多路语义召回",
                "kind": "compute",
                "detail": "多维相似度融合生成候选，兼顾命中与多样性。",
                "x": 38,
                "y": 235
            },
            {
                "id": "rank",
                "label": "圈层排序与迁移",
                "sub": "中心度 · 分布校正",
                "kind": "compute",
                "detail": "校正达人在策略圈层中的排序分布，保持分配与目标一致。",
                "x": 350,
                "y": 235
            },
            {
                "id": "joint",
                "label": "社交联合推荐",
                "sub": "组合约束",
                "kind": "compute",
                "detail": "用互动关系组织符合场景约束的达人组合。",
                "x": 662,
                "y": 235
            },
            {
                "id": "orchestrator",
                "label": "策略编排",
                "sub": "阈值 · 圈层比例 · 迁移",
                "kind": "control",
                "detail": "统一候选筛选、圈层比例与动态分发配置。",
                "x": 38,
                "y": 405
            },
            {
                "id": "feed",
                "label": "分层 Feed 与业务分发",
                "sub": "强匹配 · 延展 · 破圈",
                "kind": "entry",
                "detail": "提供推荐理由、滚动加载与业务场景接入。",
                "x": 350,
                "y": 405
            },
            {
                "id": "feedback",
                "label": "行为反馈",
                "sub": "点击 · 推荐使用",
                "kind": "data",
                "detail": "记录使用行为与反馈，支持推荐效果评估和策略迭代。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "多维输入",
                "y": 30
            },
            {
                "label": "召回与策略",
                "y": 200
            },
            {
                "label": "分发与反馈",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "content",
                "to": "recall",
                "label": "语义"
            },
            {
                "from": "social",
                "to": "joint",
                "label": "关系"
            },
            {
                "from": "goals",
                "to": "rank",
                "label": "目标"
            },
            {
                "from": "recall",
                "to": "rank",
                "label": "候选"
            },
            {
                "from": "rank",
                "to": "joint",
                "label": "组合"
            },
            {
                "from": "rank",
                "to": "orchestrator",
                "label": "策略"
            },
            {
                "from": "joint",
                "to": "feed",
                "label": "联合结果"
            },
            {
                "from": "orchestrator",
                "to": "feed",
                "label": "分发"
            },
            {
                "from": "feed",
                "to": "feedback",
                "label": "反馈"
            }
        ],
        "notes": [
            "召回、圈层分配与社交组合分别解决不同问题。"
        ]
    },
    "analytics": {
        "title": "工具构造与任务调用分离",
        "mode": "已实现逻辑架构",
        "nodes": [
            {
                "id": "question",
                "label": "自然语言问题",
                "sub": "业务分析目标",
                "kind": "entry",
                "detail": "用户问题驱动数据读取、可视化与洞察三阶段分析。",
                "x": 38,
                "y": 65
            },
            {
                "id": "schema",
                "label": "数据库结构与上下文",
                "sub": "Schema · 压缩信息",
                "kind": "data",
                "detail": "为工具生成提供结构与业务背景，控制上下文信息量。",
                "x": 350,
                "y": 65
            },
            {
                "id": "plan",
                "label": "分阶段分析计划",
                "sub": "读取 · 可视化 · 洞察",
                "kind": "control",
                "detail": "组织多轮提示编排和阶段依赖。",
                "x": 662,
                "y": 65
            },
            {
                "id": "maker",
                "label": "ToolMaker",
                "sub": "构造与验证工具函数",
                "kind": "compute",
                "detail": "自动构造分析函数并验证，形成可复用工具。",
                "x": 38,
                "y": 235
            },
            {
                "id": "user",
                "label": "ToolUser",
                "sub": "函数组合与调用推理",
                "kind": "compute",
                "detail": "根据任务选择和组合工具，复用已有分析能力。",
                "x": 350,
                "y": 235
            },
            {
                "id": "sandbox",
                "label": "私有化执行沙箱",
                "sub": "敏感数据隔离",
                "kind": "control",
                "detail": "数据提取与代码执行在受控环境完成。",
                "x": 662,
                "y": 235
            },
            {
                "id": "tools",
                "label": "分析工具库",
                "sub": "函数级复用",
                "kind": "data",
                "detail": "保存可复用分析函数，避免重复生成与推理。",
                "x": 38,
                "y": 405
            },
            {
                "id": "insight",
                "label": "可视化与分析洞察",
                "sub": "脱敏 · 指标扰动",
                "kind": "entry",
                "detail": "结果输出应用数据保护策略，形成结构化分析与可视化。",
                "x": 350,
                "y": 405
            },
            {
                "id": "eval",
                "label": "改造版 NvBench",
                "sub": "召回 · 可读性 · 工时",
                "kind": "control",
                "detail": "通过 NvBench 评测与人工对照检查分析结果、召回表现和任务耗时。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "输入与规划",
                "y": 30
            },
            {
                "label": "工具与受控执行",
                "y": 200
            },
            {
                "label": "输出与验证",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "question",
                "to": "plan",
                "label": "目标"
            },
            {
                "from": "schema",
                "to": "maker",
                "label": "结构"
            },
            {
                "from": "plan",
                "to": "user",
                "label": "调度"
            },
            {
                "from": "maker",
                "to": "tools",
                "label": "验证入库"
            },
            {
                "from": "tools",
                "to": "user",
                "label": "复用"
            },
            {
                "from": "user",
                "to": "sandbox",
                "label": "调用"
            },
            {
                "from": "sandbox",
                "to": "insight",
                "label": "结果"
            },
            {
                "from": "insight",
                "to": "eval",
                "label": "评估"
            }
        ],
        "notes": [
            "ToolMaker 的工具构造与 ToolUser 的调用推理解耦。",
            "60%、10.7% 和 70% 随相应评测范围展示。"
        ]
    },
    "motion": {
        "title": "文本意图到稳定动作序列",
        "mode": "项目逻辑架构",
        "nodes": [
            {
                "id": "text",
                "label": "中英文本指令",
                "sub": "意图 · 同义表达",
                "kind": "entry",
                "detail": "自然语言指令进入结构化动作意图解析。",
                "x": 38,
                "y": 65
            },
            {
                "id": "intent",
                "label": "LLM 指令解析",
                "sub": "多轮 Prompt · Schema",
                "kind": "compute",
                "detail": "本人负责指令解析模块，把文本转为下游可用意图。",
                "x": 350,
                "y": 65
            },
            {
                "id": "retrieval",
                "label": "语义动作检索",
                "sub": "CLIP / MotionCLIP",
                "kind": "compute",
                "detail": "将意图与动作片段 embedding 对齐并组合。",
                "x": 662,
                "y": 65
            },
            {
                "id": "library",
                "label": "动作片段与语义库",
                "sub": "检索候选",
                "kind": "data",
                "detail": "为匹配和动态组合提供候选动作片段。",
                "x": 38,
                "y": 235
            },
            {
                "id": "generation",
                "label": "动作与姿态合成",
                "sub": "生成模型 · 角色动画",
                "kind": "compute",
                "detail": "参与生成和姿态模块，连接动作片段与动画构建。",
                "x": 350,
                "y": 235
            },
            {
                "id": "pose",
                "label": "目标定位与稳定性",
                "sub": "SAM · DINO · 关键点",
                "kind": "control",
                "detail": "定位动作区域、跟踪关键点并检测姿态异常。",
                "x": 662,
                "y": 235
            },
            {
                "id": "sequence",
                "label": "动作序列修正",
                "sub": "跳变 · 穿插过滤",
                "kind": "compute",
                "detail": "分析连续帧稳定性，修正或过滤异常状态。",
                "x": 38,
                "y": 405
            },
            {
                "id": "render",
                "label": "动画渲染与虚拟人",
                "sub": "连贯表现",
                "kind": "entry",
                "detail": "形成文本驱动角色表现，面向虚拟人内容场景。",
                "x": 350,
                "y": 405
            },
            {
                "id": "verify",
                "label": "场景验证",
                "sub": "成功率 ≥80% · 3 次直播",
                "kind": "control",
                "detail": "结合主流动作生成测试与 3 次直播 3D 回验证系统表现。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "输入与检索",
                "y": 30
            },
            {
                "label": "生成与修正",
                "y": 200
            },
            {
                "label": "表现与验证",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "text",
                "to": "intent",
                "label": "解析"
            },
            {
                "from": "intent",
                "to": "retrieval",
                "label": "意图"
            },
            {
                "from": "library",
                "to": "retrieval",
                "label": "候选"
            },
            {
                "from": "retrieval",
                "to": "generation",
                "label": "动作"
            },
            {
                "from": "generation",
                "to": "pose",
                "label": "检查"
            },
            {
                "from": "pose",
                "to": "sequence",
                "label": "修正"
            },
            {
                "from": "sequence",
                "to": "render",
                "label": "渲染"
            },
            {
                "from": "render",
                "to": "verify",
                "label": "验证"
            }
        ],
        "notes": [
            "负责指令解析，参与检索、动作合成与结果修正。"
        ]
    },
    "carbon": {
        "title": "政策决策与模拟环境反馈",
        "mode": "研究实验架构",
        "nodes": [
            {
                "id": "history",
                "label": "历史能耗与经济数据",
                "sub": "能耗 · 排放 · 成本",
                "kind": "data",
                "detail": "以历史数据与假设场景定义模拟环境输入。",
                "x": 38,
                "y": 65
            },
            {
                "id": "mdp",
                "label": "MDP 状态与动作",
                "sub": "政策变量 · 延迟反馈",
                "kind": "compute",
                "detail": "本人设计状态与动作空间，表达政策干预和延迟反馈。",
                "x": 350,
                "y": 65
            },
            {
                "id": "reward",
                "label": "奖励塑形",
                "sub": "折现 · 惩罚 · 成本权衡",
                "kind": "control",
                "detail": "构造长期回报与社会成本的平衡，避免短期激进策略。",
                "x": 662,
                "y": 65
            },
            {
                "id": "environment",
                "label": "政策模拟环境",
                "sub": "场景假设与动态反馈",
                "kind": "compute",
                "detail": "在模拟环境中计算不同政策路径的碳排放与社会成本反馈。",
                "x": 38,
                "y": 235
            },
            {
                "id": "training",
                "label": "DQN / PPO 策略训练",
                "sub": "多策略对比 · 回放",
                "kind": "compute",
                "detail": "比较不同策略与假设场景，观察结果及稳定性。",
                "x": 350,
                "y": 235
            },
            {
                "id": "causal",
                "label": "因果解释",
                "sub": "因果图 · do-calculus",
                "kind": "compute",
                "detail": "解释政策行为背后的变量关系，形成可讨论的依据。",
                "x": 662,
                "y": 235
            },
            {
                "id": "replay",
                "label": "策略路径回放",
                "sub": "长期轨迹",
                "kind": "data",
                "detail": "保存策略路径和环境输出，供横向比较。",
                "x": 38,
                "y": 405
            },
            {
                "id": "metrics",
                "label": "模拟结果评估",
                "sub": "排放 · 成本 · 波动",
                "kind": "control",
                "detail": "模拟最优策略的排放、成本与波动分别评估。",
                "x": 350,
                "y": 405
            },
            {
                "id": "report",
                "label": "可解释政策研讨",
                "sub": "内部讨论 · 接受度",
                "kind": "entry",
                "detail": "结果用于研讨，不作为实际政策成效或公众验证。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "建模与假设",
                "y": 30
            },
            {
                "label": "策略实验",
                "y": 200
            },
            {
                "label": "结果与研讨",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "history",
                "to": "mdp",
                "label": "定义"
            },
            {
                "from": "mdp",
                "to": "environment",
                "label": "状态"
            },
            {
                "from": "reward",
                "to": "training",
                "label": "回报"
            },
            {
                "from": "environment",
                "to": "training",
                "label": "交互"
            },
            {
                "from": "training",
                "to": "causal",
                "label": "策略"
            },
            {
                "from": "training",
                "to": "replay",
                "label": "回放"
            },
            {
                "from": "replay",
                "to": "metrics",
                "label": "评估"
            },
            {
                "from": "causal",
                "to": "report",
                "label": "解释"
            },
            {
                "from": "metrics",
                "to": "report",
                "label": "证据"
            }
        ],
        "notes": [
            "效果指标来自模拟环境；研讨评价为 7/8。"
        ]
    },
    "logs": {
        "title": "业务集群内采集与独立告警研判",
        "mode": "当前部署逻辑架构",
        "nodes": [
            {
                "id": "timer",
                "label": "定时触发",
                "sub": "当前配置 Job",
                "kind": "control",
                "detail": "在业务组自己的 Kubernetes 集群内触发，不依赖旧 Webhook 方案。",
                "x": 38,
                "y": 65
            },
            {
                "id": "clickhouse",
                "label": "本集群 ClickHouse",
                "sub": "Error 日志",
                "kind": "data",
                "detail": "Agent 只读取所在业务集群日志，不跨集群查询。",
                "x": 350,
                "y": 65
            },
            {
                "id": "clickvisual",
                "label": "ClickVisual 基础告警",
                "sub": "独立原有链路",
                "kind": "external",
                "detail": "基础告警与 Agent 独立运行，共同支持异常发现与问题研判。",
                "x": 662,
                "y": 65
            },
            {
                "id": "collect",
                "label": "日志采集",
                "sub": "按窗口读取错误",
                "kind": "compute",
                "detail": "定时读取错误；没有错误时不进入研判或通知。",
                "x": 38,
                "y": 235
            },
            {
                "id": "assess",
                "label": "Agent 研判 Job",
                "sub": "错误 · 影响 · 排查顺序",
                "kind": "compute",
                "detail": "基于观察到的日志与命中参考文档形成诊断建议。",
                "x": 350,
                "y": 235
            },
            {
                "id": "docs",
                "label": "接口与业务参考文档",
                "sub": "诊断查询接口",
                "kind": "data",
                "detail": "文档提供理解接口语义的依据，不代替实际日志事实。",
                "x": 662,
                "y": 235
            },
            {
                "id": "quality",
                "label": "完整性检查",
                "sub": "失败不发送结论",
                "kind": "control",
                "detail": "研判失败或结果不完整时不发送不完整结论。",
                "x": 38,
                "y": 405
            },
            {
                "id": "bot",
                "label": "Lark Bot 推送",
                "sub": "中文研判结果",
                "kind": "entry",
                "detail": "当前用于发送结果，接收指令触发任务仍是扩展方向。",
                "x": 350,
                "y": 405
            },
            {
                "id": "human",
                "label": "业务与研发人员",
                "sub": "人工判断与处置",
                "kind": "entry",
                "detail": "结合错误、影响和建议推进排查，Agent 不执行生产修复。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "业务集群 · 本地数据与触发",
                "y": 30
            },
            {
                "label": "同一业务集群 · 研判执行",
                "y": 200
            },
            {
                "label": "结果控制与通知",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "timer",
                "to": "collect",
                "label": "触发",
                "kind": "control"
            },
            {
                "from": "clickhouse",
                "to": "collect",
                "label": "日志"
            },
            {
                "from": "clickhouse",
                "to": "clickvisual",
                "label": "独立查询"
            },
            {
                "from": "collect",
                "to": "assess",
                "label": "错误证据"
            },
            {
                "from": "docs",
                "to": "assess",
                "label": "参考资料"
            },
            {
                "from": "assess",
                "to": "quality",
                "label": "结果"
            },
            {
                "from": "quality",
                "to": "bot",
                "label": "有效结果",
                "kind": "control"
            },
            {
                "from": "bot",
                "to": "human",
                "label": "通知"
            }
        ],
        "notes": [
            "各业务组独立部署，数据和权限边界留在本集群。",
            "自动生成 SQL、自定义策略和指令触发属于后续设计。"
        ]
    },
    "pr-review": {
        "title": "固定版本的跨仓库影响审查",
        "mode": "试点方案架构",
        "nodes": [
            {
                "id": "lark",
                "label": "发版模板与范围确认",
                "sub": "明确仓库和 MR",
                "kind": "entry",
                "detail": "以经审核的发布清单界定跨仓审查范围，绑定代码版本与检查规则。",
                "x": 38,
                "y": 65
            },
            {
                "id": "gitlab",
                "label": "GitLab 事实源",
                "sub": "Head · Base · Diff · CI",
                "kind": "external",
                "detail": "控制面重新拉取事实，Webhook 只通知变更。",
                "x": 350,
                "y": 65
            },
            {
                "id": "snapshot",
                "label": "不可变审核快照",
                "sub": "代码 · 规则 · 版本",
                "kind": "data",
                "detail": "冻结代码与策略版本，旧快照不覆盖当前结论。",
                "x": 662,
                "y": 65
            },
            {
                "id": "orchestrator",
                "label": "CrossRepo Orchestrator",
                "sub": "状态 · 配额 · 租约",
                "kind": "compute",
                "detail": "编排多 MR 任务、重试和取消，管理会话与审计。",
                "x": 38,
                "y": 235
            },
            {
                "id": "kernel",
                "label": "PR-Agent 内核 / Worker",
                "sub": "单 MR 审查",
                "kind": "compute",
                "detail": "复用单仓库内核，结合已授权代码和规则生成结果。",
                "x": 350,
                "y": 235
            },
            {
                "id": "runner",
                "label": "受限 Runner",
                "sub": "固定命令 · 临时沙箱",
                "kind": "control",
                "detail": "仅在授权执行域运行构建、静态检查或单测，不由模型任意执行。",
                "x": 662,
                "y": 235
            },
            {
                "id": "relations",
                "label": "依赖与契约证据",
                "sub": "调用点 · IDL · 消息资源",
                "kind": "data",
                "detail": "在选定范围内检索关系，区分 confirmed、candidate 与 unknown。",
                "x": 38,
                "y": 405
            },
            {
                "id": "result",
                "label": "结果聚合",
                "sub": "Finding · 失败 · 证据",
                "kind": "compute",
                "detail": "归一化单仓结果、去重并保留失败项和联合验证缺口。",
                "x": 350,
                "y": 405
            },
            {
                "id": "report",
                "label": "版本化报告",
                "sub": "机器结果 + 人类阅读",
                "kind": "entry",
                "detail": "报告引用固定快照；方案首期不自动阻断合并或执行发布。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "范围与事实",
                "y": 30
            },
            {
                "label": "控制面与执行域",
                "y": 200
            },
            {
                "label": "关系、汇总与报告",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "lark",
                "to": "orchestrator",
                "label": "确认范围"
            },
            {
                "from": "gitlab",
                "to": "snapshot",
                "label": "冻结"
            },
            {
                "from": "snapshot",
                "to": "kernel",
                "label": "事实"
            },
            {
                "from": "orchestrator",
                "to": "kernel",
                "label": "分发"
            },
            {
                "from": "kernel",
                "to": "runner",
                "label": "授权检查",
                "kind": "control"
            },
            {
                "from": "orchestrator",
                "to": "relations",
                "label": "关系分析"
            },
            {
                "from": "kernel",
                "to": "result",
                "label": "审查结果"
            },
            {
                "from": "runner",
                "to": "result",
                "label": "验证证据"
            },
            {
                "from": "relations",
                "to": "result",
                "label": "影响边"
            },
            {
                "from": "result",
                "to": "report",
                "label": "报告"
            }
        ],
        "notes": [
            "单仓内核复用；跨仓价值集中在范围、事实快照和关系证据。",
            "架构为试点方案与样本验证，不表示统一生产准入已部署。"
        ]
    },
    "locate": {
        "title": "表格翻译与一致性核对",
        "mode": "初版工作流架构",
        "nodes": [
            {
                "id": "input",
                "label": "xlsx / 多子表",
                "sub": "列配置 · 目标语言",
                "kind": "entry",
                "detail": "输入工作表与翻译列，保留表格结构。",
                "x": 38,
                "y": 65
            },
            {
                "id": "rules",
                "label": "术语与风格预设",
                "sub": "保留词 · 变量 · 数字",
                "kind": "control",
                "detail": "明确不能改动的词与变量，以及目标语言和同表术语规则。",
                "x": 350,
                "y": 65
            },
            {
                "id": "translate",
                "label": "批量翻译任务",
                "sub": "模型调用 · 术语复用",
                "kind": "compute",
                "detail": "按配置组织翻译，复用同表术语。",
                "x": 662,
                "y": 65
            },
            {
                "id": "check",
                "label": "内容与格式校验",
                "sub": "变量 · 脚本 · 一致性",
                "kind": "control",
                "detail": "检测保留词、目标语言及输入边界，质量仍需人员判断。",
                "x": 38,
                "y": 235
            },
            {
                "id": "review",
                "label": "业务试用与回归",
                "sub": "真实表格核对",
                "kind": "entry",
                "detail": "用真实翻译需求确认结果并修复边界。",
                "x": 350,
                "y": 235
            },
            {
                "id": "result",
                "label": "译文与词表沉淀",
                "sub": "复用资料",
                "kind": "data",
                "detail": "输出翻译结果和可复用配置。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "input",
                "to": "rules",
                "label": ""
            },
            {
                "from": "rules",
                "to": "translate",
                "label": ""
            },
            {
                "from": "translate",
                "to": "check",
                "label": ""
            },
            {
                "from": "check",
                "to": "review",
                "label": ""
            },
            {
                "from": "review",
                "to": "result",
                "label": ""
            }
        ],
        "notes": [
            "同表术语复用与变量保护贯穿批处理。",
            "已交付初版，持续推进真实业务试用与翻译质量验证。"
        ]
    },
    "adk": {
        "title": "独立任务空间与不可变 ContextPack",
        "mode": "阶段实现架构",
        "nodes": [
            {
                "id": "manifest",
                "label": "任务 / Agent 定义",
                "sub": "输入 · 证据组 · 工具",
                "kind": "entry",
                "detail": "任务清单明确必需上下文、工具能力和约束。",
                "x": 38,
                "y": 65
            },
            {
                "id": "truth",
                "label": "不可变真源导入",
                "sub": "来源 · 版本 · 摘要",
                "kind": "data",
                "detail": "导入资料保留来源与摘要，防止构建过程中证据漂移。",
                "x": 350,
                "y": 65
            },
            {
                "id": "catalog",
                "label": "Catalog 与契约",
                "sub": "精确匹配 · 必需组",
                "kind": "control",
                "detail": "检查来源与必需证据，缺口默认阻断。",
                "x": 662,
                "y": 65
            },
            {
                "id": "job",
                "label": "Per-job 独立空间",
                "sub": "隔离 · 并发锁",
                "kind": "compute",
                "detail": "每个构建任务独立，避免资料串包与并发重复。",
                "x": 38,
                "y": 235
            },
            {
                "id": "pack",
                "label": "ContextPack / Manifest",
                "sub": "摘要 · 引用 · 清单",
                "kind": "data",
                "detail": "上下文包明确每份证据来源与构建版本。",
                "x": 350,
                "y": 235
            },
            {
                "id": "execute",
                "label": "业务 Agent 执行",
                "sub": "CLI · MCP · 跨语言接口",
                "kind": "compute",
                "detail": "将确定性上下文构建与业务推理执行分开。",
                "x": 662,
                "y": 235
            },
            {
                "id": "reuse",
                "label": "幂等复用",
                "sub": "一致输入复用结果",
                "kind": "control",
                "detail": "对相同输入复用构建，避免重复工作。",
                "x": 38,
                "y": 405
            },
            {
                "id": "archive",
                "label": "可恢复归档",
                "sub": "任务记录 · 证据",
                "kind": "data",
                "detail": "归档保留任务与证据，失败后有明确恢复入口。",
                "x": 350,
                "y": 405
            },
            {
                "id": "verify",
                "label": "契约与本地回归",
                "sub": "隔离 · 校验 · 恢复",
                "kind": "control",
                "detail": "本地测试不代替生产级并发和发布验收。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "任务定义与真源",
                "y": 30
            },
            {
                "label": "构建与执行",
                "y": 200
            },
            {
                "label": "可靠性与追踪",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "manifest",
                "to": "job",
                "label": "定义"
            },
            {
                "from": "truth",
                "to": "pack",
                "label": "证据"
            },
            {
                "from": "catalog",
                "to": "pack",
                "label": "校验",
                "kind": "control"
            },
            {
                "from": "job",
                "to": "pack",
                "label": "构建"
            },
            {
                "from": "pack",
                "to": "execute",
                "label": "上下文"
            },
            {
                "from": "job",
                "to": "reuse",
                "label": "任务键"
            },
            {
                "from": "execute",
                "to": "archive",
                "label": "运行记录"
            },
            {
                "from": "archive",
                "to": "verify",
                "label": "复验"
            }
        ],
        "notes": [
            "隔离、校验、幂等和归档围绕同一个任务证据链。"
        ]
    },
    "qa": {
        "title": "需求、用例和执行回执的版本闭环",
        "mode": "本地初版架构",
        "nodes": [
            {
                "id": "source",
                "label": "需求原文 / 验收表",
                "sub": "不可变输入快照",
                "kind": "data",
                "detail": "保留原文与验收表；修改输入后旧关联失效。",
                "x": 38,
                "y": 65
            },
            {
                "id": "draft",
                "label": "结构化用例生成",
                "sub": "显式转换 / 可选模型草稿",
                "kind": "compute",
                "detail": "从验收表转换用例，模型只用于可选草稿。",
                "x": 350,
                "y": 65
            },
            {
                "id": "schema",
                "label": "Schema 与来源检查",
                "sub": "ULID · 结构 · 来源",
                "kind": "control",
                "detail": "检查格式与来源，不将结构合法当作业务覆盖正确。",
                "x": 662,
                "y": 65
            },
            {
                "id": "review",
                "label": "人工评审与映射",
                "sub": "当前版本批准",
                "kind": "entry",
                "detail": "人工核对用例、断言和操作映射，输入变更撤销批准。",
                "x": 38,
                "y": 235
            },
            {
                "id": "package",
                "label": "不可变执行工作包",
                "sub": "来源 · 环境 · 执行器",
                "kind": "data",
                "detail": "固定任务、环境和执行器摘要，作为回执核对依据。",
                "x": 350,
                "y": 235
            },
            {
                "id": "runner",
                "label": "独立 Playwright 执行",
                "sub": "本机明确测试环境",
                "kind": "compute",
                "detail": "工作台导出执行包，执行器独立运行，不由工作台暗中启动浏览器。",
                "x": 662,
                "y": 235
            },
            {
                "id": "receipt",
                "label": "执行回执导入",
                "sub": "成功 · 失败 · 取消",
                "kind": "entry",
                "detail": "回执保留真实状态和未执行步骤。",
                "x": 38,
                "y": 405
            },
            {
                "id": "check",
                "label": "回执绑定校验",
                "sub": "哈希 · 运行登记",
                "kind": "control",
                "detail": "核对当前运行快照，拒绝来源或环境不匹配结果。",
                "x": 350,
                "y": 405
            },
            {
                "id": "archive",
                "label": "本地版本归档",
                "sub": "用例 · 映射 · 回执",
                "kind": "data",
                "detail": "保存可恢复工作包，不将归档等同生产验收。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "输入与生成",
                "y": 30
            },
            {
                "label": "评审与执行包",
                "y": 200
            },
            {
                "label": "回执与归档",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "source",
                "to": "draft",
                "label": "生成"
            },
            {
                "from": "draft",
                "to": "schema",
                "label": "校验"
            },
            {
                "from": "schema",
                "to": "review",
                "label": "待核对"
            },
            {
                "from": "review",
                "to": "package",
                "label": "批准",
                "kind": "control"
            },
            {
                "from": "package",
                "to": "runner",
                "label": "导出"
            },
            {
                "from": "runner",
                "to": "receipt",
                "label": "执行结果"
            },
            {
                "from": "receipt",
                "to": "check",
                "label": "核对",
                "kind": "control"
            },
            {
                "from": "check",
                "to": "archive",
                "label": "保存"
            }
        ],
        "notes": [
            "人工评审绑定当前版本，旧回执不能覆盖修改后的用例。",
            "已验证本地与合成目标；真实业务覆盖及模型质量另行验收。"
        ]
    },
    "figma": {
        "title": "语境匹配、冲突审阅与文案输出",
        "mode": "本地初版架构",
        "nodes": [
            {
                "id": "nodes",
                "label": "Figma 文本节点 JSON",
                "sub": "页面 / 选区 · 来源",
                "kind": "entry",
                "detail": "插件只读取文本节点；真实宿主仍待验证。",
                "x": 38,
                "y": 65
            },
            {
                "id": "table",
                "label": "语言表与严格匹配",
                "sub": "Key · Locale · 原文 · 语境",
                "kind": "data",
                "detail": "节点与 CSV 联合匹配，文本相同不自动归为复用。",
                "x": 350,
                "y": 65
            },
            {
                "id": "conflict",
                "label": "候选与冲突检测",
                "sub": "目标 Key · 重复项",
                "kind": "control",
                "detail": "显式暴露不同文案、语境和重复 Key 的冲突。",
                "x": 662,
                "y": 65
            },
            {
                "id": "review",
                "label": "人工审阅",
                "sub": "新增 · 复用 · 更新",
                "kind": "entry",
                "detail": "决定绑定节点、语言表、语言与规则版本，保留操作者及原因。",
                "x": 38,
                "y": 235
            },
            {
                "id": "version",
                "label": "版本保存与恢复",
                "sub": "输入指纹 · 历史追加",
                "kind": "data",
                "detail": "输入变化后重新匹配，旧决定不能沿用。",
                "x": 350,
                "y": 235
            },
            {
                "id": "export",
                "label": "最终表与审阅记录",
                "sub": "CSV · JSON",
                "kind": "entry",
                "detail": "未决项和 Key 冲突处理完毕才生成最终输出，不回写在线设计稿。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "nodes",
                "to": "table",
                "label": ""
            },
            {
                "from": "table",
                "to": "conflict",
                "label": ""
            },
            {
                "from": "conflict",
                "to": "review",
                "label": ""
            },
            {
                "from": "review",
                "to": "version",
                "label": ""
            },
            {
                "from": "version",
                "to": "export",
                "label": ""
            }
        ],
        "notes": [
            "图示为节点 JSON 导入后的本地工作流。",
            "原型覆盖文案提取、语言表匹配与人工审阅，Figma 宿主联调为下一阶段工作。"
        ]
    },
    "prd": {
        "title": "从原文证据到可交互需求表达",
        "mode": "本地初版架构",
        "nodes": [
            {
                "id": "source",
                "label": "需求原文",
                "sub": "段落 ID · 原始行号",
                "kind": "data",
                "detail": "原始需求独立保存，不用整理稿覆盖。",
                "x": 38,
                "y": 65
            },
            {
                "id": "mapping",
                "label": "需求整理与原文映射",
                "sub": "可选模型建议 · 逐字引用",
                "kind": "compute",
                "detail": "整理需求关联原文定位与引用，由产品人员核对业务含义。",
                "x": 350,
                "y": 65
            },
            {
                "id": "review",
                "label": "人工核对与确认",
                "sub": "输入版本绑定",
                "kind": "control",
                "detail": "人工确认业务含义，原文或需求变化后旧确认失效。",
                "x": 662,
                "y": 65
            },
            {
                "id": "generation",
                "label": "受控模板生成",
                "sub": "List · Board · Form",
                "kind": "compute",
                "detail": "同步生成 1—5 页通用交互原型与 PRD。",
                "x": 38,
                "y": 235
            },
            {
                "id": "preview",
                "label": "隔离交互预览",
                "sub": "搜索 · 表单 · 详情",
                "kind": "entry",
                "detail": "在隔离预览中呈现列表、看板、表单与详情等模板交互。",
                "x": 350,
                "y": 235
            },
            {
                "id": "archive",
                "label": "PRD / 原型 / 对应表",
                "sub": "单文件 HTML · 版本差异",
                "kind": "data",
                "detail": "保留源文、需求、页面映射和历史变化。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "source",
                "to": "mapping",
                "label": ""
            },
            {
                "from": "mapping",
                "to": "review",
                "label": ""
            },
            {
                "from": "review",
                "to": "generation",
                "label": ""
            },
            {
                "from": "generation",
                "to": "preview",
                "label": ""
            },
            {
                "from": "preview",
                "to": "archive",
                "label": ""
            }
        ],
        "notes": [
            "原文证据、业务核对和原型交互是三个不同检查面。"
        ]
    },
    "cover": {
        "title": "素材真源与美术草稿分层",
        "mode": "本地初版架构",
        "nodes": [
            {
                "id": "catalog",
                "label": "游戏台账与明确来源",
                "sub": "厂商目录 · 游戏身份",
                "kind": "entry",
                "detail": "按名称与厂商核对身份，不以模糊匹配补全来源。",
                "x": 38,
                "y": 65
            },
            {
                "id": "crawl",
                "label": "目录 / 页面采集",
                "sub": "适配器 · 受控下载",
                "kind": "compute",
                "detail": "跟随明确来源下载素材，限制文件与解包资源。",
                "x": 350,
                "y": 65
            },
            {
                "id": "assets",
                "label": "内容寻址素材库",
                "sub": "包成员 · SHA-256",
                "kind": "data",
                "detail": "记录素材来源、时间及原包关系，以内容哈希进行文件去重。",
                "x": 662,
                "y": 65
            },
            {
                "id": "jobs",
                "label": "可恢复批量任务",
                "sub": "串行步骤 · 状态落盘",
                "kind": "control",
                "detail": "按批次处理，支持暂停续跑及失败重试，不声称分布式调度。",
                "x": 38,
                "y": 235
            },
            {
                "id": "analysis",
                "label": "选定图像分析",
                "sub": "可选模型 / 导入草稿",
                "kind": "compute",
                "detail": "按明确选图组织分析，区分图片观察、玩法事实与设计建议。",
                "x": 350,
                "y": 235
            },
            {
                "id": "target",
                "label": "目标参考与风格要求",
                "sub": "人工提供",
                "kind": "entry",
                "detail": "目标图与游戏素材分别保留来源和用途。",
                "x": 662,
                "y": 235
            },
            {
                "id": "review",
                "label": "来源校验与人工核对",
                "sub": "图片 · 引文 · 缺口",
                "kind": "control",
                "detail": "分别校验素材完整性与设计判断，记录人工美术审阅结果。",
                "x": 38,
                "y": 405
            },
            {
                "id": "cards",
                "label": "分析卡 / 风格卡",
                "sub": "草稿版本",
                "kind": "data",
                "detail": "形成可维护游戏与风格资料，修改后重新校验。",
                "x": 350,
                "y": 405
            },
            {
                "id": "export",
                "label": "创作准备工作包",
                "sub": "Brief · Style · 原图引用",
                "kind": "entry",
                "detail": "输出设计草稿与工作包，供美术团队审阅和后续创作使用。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "素材输入",
                "y": 30
            },
            {
                "label": "任务与分析",
                "y": 200
            },
            {
                "label": "美术协作与归档",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "catalog",
                "to": "crawl",
                "label": "来源"
            },
            {
                "from": "crawl",
                "to": "assets",
                "label": "素材"
            },
            {
                "from": "catalog",
                "to": "jobs",
                "label": "批次"
            },
            {
                "from": "assets",
                "to": "analysis",
                "label": "选图"
            },
            {
                "from": "target",
                "to": "analysis",
                "label": "参考"
            },
            {
                "from": "analysis",
                "to": "review",
                "label": "草稿"
            },
            {
                "from": "review",
                "to": "cards",
                "label": "核对"
            },
            {
                "from": "cards",
                "to": "export",
                "label": "导出"
            }
        ],
        "notes": [
            "素材来源与设计判断分开保存；模型输出保持草稿。"
        ]
    },
    "gateway": {
        "title": "模型访问入口与资源治理",
        "mode": "生产服务逻辑架构",
        "nodes": [
            {
                "id": "client",
                "label": "业务应用 / 开发工具",
                "sub": "模型请求",
                "kind": "entry",
                "detail": "业务应用经统一入口访问模型。",
                "x": 38,
                "y": 65
            },
            {
                "id": "auth",
                "label": "API Key 与接入控制",
                "sub": "授权 · 使用范围",
                "kind": "control",
                "detail": "管理使用入口和访问资格。",
                "x": 350,
                "y": 65
            },
            {
                "id": "router",
                "label": "账号与模型路由",
                "sub": "上游选择 · 请求处理",
                "kind": "compute",
                "detail": "组织账号路由与请求处理，隔离业务接入和上游能力。",
                "x": 662,
                "y": 65
            },
            {
                "id": "provider",
                "label": "上游模型服务",
                "sub": "文本 / 多模态",
                "kind": "external",
                "detail": "外部模型负责推理，具体能力按接入版本验证。",
                "x": 38,
                "y": 235
            },
            {
                "id": "usage",
                "label": "用量与运行观测",
                "sub": "成本 · TTFT · 错误",
                "kind": "data",
                "detail": "记录用量和请求表现，用于资源与故障诊断。",
                "x": 350,
                "y": 235
            },
            {
                "id": "ops",
                "label": "管理与迭代",
                "sub": "账号状态 · 配置 · 发布",
                "kind": "entry",
                "detail": "后台资源治理与部署核查形成运维流程。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "client",
                "to": "auth",
                "label": ""
            },
            {
                "from": "auth",
                "to": "router",
                "label": ""
            },
            {
                "from": "router",
                "to": "provider",
                "label": ""
            },
            {
                "from": "provider",
                "to": "usage",
                "label": ""
            },
            {
                "from": "usage",
                "to": "ops",
                "label": ""
            }
        ],
        "notes": [
            "模型访问、账号路由与资源观测分层管理。"
        ]
    },
    "logs-mcp": {
        "title": "从代码问题到授权日志证据",
        "mode": "工具服务逻辑架构",
        "nodes": [
            {
                "id": "agent",
                "label": "Coding Agent / 客户端",
                "sub": "问题 · 代码上下文",
                "kind": "entry",
                "detail": "开发者给出问题与相关代码，收敛查询意图。",
                "x": 38,
                "y": 65
            },
            {
                "id": "auth",
                "label": "MCP 鉴权入口",
                "sub": "Streamable HTTP · API Key",
                "kind": "control",
                "detail": "按客户端协议完成鉴权，不绕过权限。",
                "x": 350,
                "y": 65
            },
            {
                "id": "tools",
                "label": "Logs MCP 工具服务",
                "sub": "数据源发现 · 只读查询",
                "kind": "compute",
                "detail": "以受控工具提供日志能力；响应限制与数据库成本控制分别负责。",
                "x": 662,
                "y": 65
            },
            {
                "id": "db",
                "label": "ClickHouse 数据源",
                "sub": "时间 · 服务 · Trace 范围",
                "kind": "data",
                "detail": "按明确条件读取日志，控制范围和扫描资源。",
                "x": 38,
                "y": 235
            },
            {
                "id": "evidence",
                "label": "日志与代码关联",
                "sub": "观察事实 · 原因推断",
                "kind": "compute",
                "detail": "以 trace/request 等关联路径，区分证据与假设。",
                "x": 350,
                "y": 235
            },
            {
                "id": "report",
                "label": "诊断与修复建议",
                "sub": "人工复核",
                "kind": "entry",
                "detail": "输出排障依据，生产变更由人员审核。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "agent",
                "to": "auth",
                "label": ""
            },
            {
                "from": "auth",
                "to": "tools",
                "label": ""
            },
            {
                "from": "tools",
                "to": "db",
                "label": ""
            },
            {
                "from": "db",
                "to": "evidence",
                "label": ""
            },
            {
                "from": "evidence",
                "to": "report",
                "label": ""
            }
        ],
        "notes": [
            "默认只读。协议兼容、轮换和配额按环境单独验证。"
        ]
    },
    "aletheia": {
        "title": "分层真源到知识应用的原型",
        "mode": "原型逻辑架构",
        "nodes": [
            {
                "id": "lark",
                "label": "Lark 真源",
                "sub": "资料与版本",
                "kind": "entry",
                "detail": "原型接入的知识资料来源。",
                "x": 38,
                "y": 65
            },
            {
                "id": "levels",
                "label": "L0 / L1 / L2 / L3",
                "sub": "分层知识处理",
                "kind": "compute",
                "detail": "按原型定义处理真源、分层资料与知识关系。",
                "x": 350,
                "y": 65
            },
            {
                "id": "db",
                "label": "PostgreSQL 知识存储",
                "sub": "Chunks · 索引",
                "kind": "data",
                "detail": "保存可检索知识资料和相关结构。",
                "x": 662,
                "y": 65
            },
            {
                "id": "api",
                "label": "Rust API",
                "sub": "检索与服务接口",
                "kind": "compute",
                "detail": "为 Agent 与 Web 提供检索服务。",
                "x": 38,
                "y": 235
            },
            {
                "id": "agent",
                "label": "Agent / MCP",
                "sub": "查询改写 · 上下文",
                "kind": "compute",
                "detail": "组织查询和任务上下文。",
                "x": 350,
                "y": 235
            },
            {
                "id": "web",
                "label": "Web 与原型评测",
                "sub": "查询 · 评测种子",
                "kind": "entry",
                "detail": "展示与验证原型能力；真实运行闭环仍需核对。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "lark",
                "to": "levels",
                "label": ""
            },
            {
                "from": "levels",
                "to": "db",
                "label": ""
            },
            {
                "from": "db",
                "to": "api",
                "label": ""
            },
            {
                "from": "api",
                "to": "agent",
                "label": ""
            },
            {
                "from": "agent",
                "to": "web",
                "label": ""
            }
        ],
        "notes": [
            "当前为分层知识原型，真实服务与使用方验收仍待完善。"
        ]
    },
    "payment-alerts": {
        "title": "支付成功率与异常通知",
        "mode": "业务数据流",
        "nodes": [
            {
                "id": "events",
                "label": "业务事件与状态",
                "sub": "交易 / 获客事件",
                "kind": "entry",
                "detail": "按具体场景接入已定义事件，保留业务时间与状态。",
                "x": 38,
                "y": 65
            },
            {
                "id": "metrics",
                "label": "实时指标与窗口聚合",
                "sub": "统一统计口径",
                "kind": "compute",
                "detail": "按业务窗口聚合，处理状态变化和结果核对。",
                "x": 350,
                "y": 65
            },
            {
                "id": "result",
                "label": "指标与原因汇总",
                "sub": "成功率 / 原因 / 转化",
                "kind": "data",
                "detail": "输出场景需要的汇总数据，不跨场景套用指标。",
                "x": 662,
                "y": 65
            },
            {
                "id": "rule",
                "label": "通知条件与模板",
                "sub": "业务确认",
                "kind": "control",
                "detail": "按业务需要检查通知条件与展示口径。",
                "x": 38,
                "y": 235
            },
            {
                "id": "push",
                "label": "定时推送 / 预警",
                "sub": "业务通知渠道",
                "kind": "entry",
                "detail": "将结果送到约定业务使用入口。",
                "x": 350,
                "y": 235
            },
            {
                "id": "review",
                "label": "业务核验与反馈",
                "sub": "口径 · 格式 · 异常",
                "kind": "control",
                "detail": "需求方核对数据和模板，问题回到指标与实现修正。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "events",
                "to": "metrics",
                "label": ""
            },
            {
                "from": "metrics",
                "to": "result",
                "label": ""
            },
            {
                "from": "result",
                "to": "rule",
                "label": ""
            },
            {
                "from": "rule",
                "to": "push",
                "label": ""
            },
            {
                "from": "push",
                "to": "review",
                "label": ""
            }
        ],
        "notes": [
            "基于业务统计窗口聚合指标，通过实时数据平台支持监控与通知。"
        ]
    },
    "withdrawal": {
        "title": "提现失败原因监控",
        "mode": "业务数据流",
        "nodes": [
            {
                "id": "events",
                "label": "业务事件与状态",
                "sub": "交易 / 获客事件",
                "kind": "entry",
                "detail": "按具体场景接入已定义事件，保留业务时间与状态。",
                "x": 38,
                "y": 65
            },
            {
                "id": "metrics",
                "label": "实时指标与窗口聚合",
                "sub": "统一统计口径",
                "kind": "compute",
                "detail": "按业务窗口聚合，处理状态变化和结果核对。",
                "x": 350,
                "y": 65
            },
            {
                "id": "result",
                "label": "指标与原因汇总",
                "sub": "成功率 / 原因 / 转化",
                "kind": "data",
                "detail": "输出场景需要的汇总数据，不跨场景套用指标。",
                "x": 662,
                "y": 65
            },
            {
                "id": "rule",
                "label": "通知条件与模板",
                "sub": "业务确认",
                "kind": "control",
                "detail": "按业务需要检查通知条件与展示口径。",
                "x": 38,
                "y": 235
            },
            {
                "id": "push",
                "label": "定时推送 / 预警",
                "sub": "业务通知渠道",
                "kind": "entry",
                "detail": "将结果送到约定业务使用入口。",
                "x": 350,
                "y": 235
            },
            {
                "id": "review",
                "label": "业务核验与反馈",
                "sub": "口径 · 格式 · 异常",
                "kind": "control",
                "detail": "需求方核对数据和模板，问题回到指标与实现修正。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "events",
                "to": "metrics",
                "label": ""
            },
            {
                "from": "metrics",
                "to": "result",
                "label": ""
            },
            {
                "from": "result",
                "to": "rule",
                "label": ""
            },
            {
                "from": "rule",
                "to": "push",
                "label": ""
            },
            {
                "from": "push",
                "to": "review",
                "label": ""
            }
        ],
        "notes": [
            "基于业务统计窗口聚合指标，通过实时数据平台支持监控与通知。"
        ]
    },
    "acquisition": {
        "title": "获客漏斗转化监控",
        "mode": "业务数据流",
        "nodes": [
            {
                "id": "events",
                "label": "业务事件与状态",
                "sub": "交易 / 获客事件",
                "kind": "entry",
                "detail": "按具体场景接入已定义事件，保留业务时间与状态。",
                "x": 38,
                "y": 65
            },
            {
                "id": "metrics",
                "label": "实时指标与窗口聚合",
                "sub": "统一统计口径",
                "kind": "compute",
                "detail": "按业务窗口聚合，处理状态变化和结果核对。",
                "x": 350,
                "y": 65
            },
            {
                "id": "result",
                "label": "指标与原因汇总",
                "sub": "成功率 / 原因 / 转化",
                "kind": "data",
                "detail": "输出场景需要的汇总数据，不跨场景套用指标。",
                "x": 662,
                "y": 65
            },
            {
                "id": "rule",
                "label": "通知条件与模板",
                "sub": "业务确认",
                "kind": "control",
                "detail": "按业务需要检查通知条件与展示口径。",
                "x": 38,
                "y": 235
            },
            {
                "id": "push",
                "label": "定时推送 / 预警",
                "sub": "业务通知渠道",
                "kind": "entry",
                "detail": "将结果送到约定业务使用入口。",
                "x": 350,
                "y": 235
            },
            {
                "id": "review",
                "label": "业务核验与反馈",
                "sub": "口径 · 格式 · 异常",
                "kind": "control",
                "detail": "需求方核对数据和模板，问题回到指标与实现修正。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "events",
                "to": "metrics",
                "label": ""
            },
            {
                "from": "metrics",
                "to": "result",
                "label": ""
            },
            {
                "from": "result",
                "to": "rule",
                "label": ""
            },
            {
                "from": "rule",
                "to": "push",
                "label": ""
            },
            {
                "from": "push",
                "to": "review",
                "label": ""
            }
        ],
        "notes": [
            "基于业务统计窗口聚合指标，通过实时数据平台支持监控与通知。"
        ]
    },
    "vip-platform": {
        "title": "会员数据服务的交付链路",
        "mode": "业务数据流",
        "nodes": [
            {
                "id": "requirements",
                "label": "会员业务规则",
                "sub": "接口与字段约定",
                "kind": "entry",
                "detail": "业务方定义会员体系数据和接口需要。",
                "x": 38,
                "y": 65
            },
            {
                "id": "history",
                "label": "历史 / 冷启动数据",
                "sub": "数据完备性",
                "kind": "data",
                "detail": "组织冷启动数据与历史输入。",
                "x": 350,
                "y": 65
            },
            {
                "id": "service",
                "label": "数据服务与脚本",
                "sub": "业务计算 · 接口适配",
                "kind": "compute",
                "detail": "数据团队实现规则与接口适配。",
                "x": 662,
                "y": 65
            },
            {
                "id": "check",
                "label": "真实数据核验",
                "sub": "冷启动 · 接口回归",
                "kind": "control",
                "detail": "发现并修复数据和接口不一致。",
                "x": 38,
                "y": 235
            },
            {
                "id": "pre",
                "label": "预发布验证",
                "sub": "业务协同",
                "kind": "control",
                "detail": "发布前共同核对数据与变更。",
                "x": 350,
                "y": 235
            },
            {
                "id": "production",
                "label": "上线与结果复核",
                "sub": "生产交付",
                "kind": "entry",
                "detail": "按明确业务口径完成上线核对。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "requirements",
                "to": "history",
                "label": ""
            },
            {
                "from": "history",
                "to": "service",
                "label": ""
            },
            {
                "from": "service",
                "to": "check",
                "label": ""
            },
            {
                "from": "check",
                "to": "pre",
                "label": ""
            },
            {
                "from": "pre",
                "to": "production",
                "label": ""
            }
        ],
        "notes": [
            "业务数据流连接接口变更、规则适配与上线验证。"
        ]
    },
    "subgames": {
        "title": "规则、配置与实现的一致性验证",
        "mode": "研发验证流程",
        "nodes": [
            {
                "id": "rules",
                "label": "玩法与业务规则",
                "sub": "需求定义",
                "kind": "entry",
                "detail": "明确需求与规则范围。",
                "x": 38,
                "y": 65
            },
            {
                "id": "design",
                "label": "数值与配置方案",
                "sub": "边界 · 参数",
                "kind": "data",
                "detail": "统一规则配置与实现口径。",
                "x": 350,
                "y": 65
            },
            {
                "id": "implementation",
                "label": "服务端与表现实现",
                "sub": "接口分工",
                "kind": "compute",
                "detail": "划分服务端与表现层责任。",
                "x": 662,
                "y": 65
            },
            {
                "id": "simulation",
                "label": "离线模拟与测试",
                "sub": "场景覆盖",
                "kind": "compute",
                "detail": "通过模拟与测试发现配置和边界问题。",
                "x": 38,
                "y": 235
            },
            {
                "id": "review",
                "label": "覆盖评审与修正",
                "sub": "一致性核对",
                "kind": "control",
                "detail": "把问题回到规则、配置与实现。",
                "x": 350,
                "y": 235
            },
            {
                "id": "delivery",
                "label": "阶段交付与业务验收",
                "sub": "逐项核对",
                "kind": "entry",
                "detail": "按子项目组织离线模拟、集成测试和业务验收，跟踪交付进展。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "rules",
                "to": "design",
                "label": ""
            },
            {
                "from": "design",
                "to": "implementation",
                "label": ""
            },
            {
                "from": "implementation",
                "to": "simulation",
                "label": ""
            },
            {
                "from": "simulation",
                "to": "review",
                "label": ""
            },
            {
                "from": "review",
                "to": "delivery",
                "label": ""
            }
        ],
        "notes": [
            "通过需求、规则、模拟与验证环节协调子游戏研发。"
        ]
    },
    "piggy": {
        "title": "游戏状态、服务结果与表现核对",
        "mode": "阶段运行链路",
        "nodes": [
            {
                "id": "ui",
                "label": "Creator 游戏表现",
                "sub": "输入 · 交互",
                "kind": "entry",
                "detail": "游戏表现与交互输入。",
                "x": 38,
                "y": 65
            },
            {
                "id": "service",
                "label": "后端结果服务",
                "sub": "既有结果库",
                "kind": "compute",
                "detail": "使用已接入后端结果，不以表现层代替规则结果。",
                "x": 350,
                "y": 65
            },
            {
                "id": "db",
                "label": "历史结果与状态",
                "sub": "持久化数据",
                "kind": "data",
                "detail": "保留历史结果与恢复依据。",
                "x": 662,
                "y": 65
            },
            {
                "id": "restore",
                "label": "状态恢复与结算核对",
                "sub": "结果一致性",
                "kind": "compute",
                "detail": "核对恢复、显示和结算。",
                "x": 38,
                "y": 235
            },
            {
                "id": "visual",
                "label": "玩法与视觉规则",
                "sub": "表现对齐",
                "kind": "control",
                "detail": "检查实际运行表现与已定义规则。",
                "x": 350,
                "y": 235
            },
            {
                "id": "verify",
                "label": "服务与数据库对账",
                "sub": "阶段验证",
                "kind": "control",
                "detail": "部分真实链路已有对账；特殊玩法等整体验收继续推进。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "ui",
                "to": "service",
                "label": ""
            },
            {
                "from": "service",
                "to": "db",
                "label": ""
            },
            {
                "from": "db",
                "to": "restore",
                "label": ""
            },
            {
                "from": "restore",
                "to": "visual",
                "label": ""
            },
            {
                "from": "visual",
                "to": "verify",
                "label": ""
            }
        ],
        "notes": [
            "Piggy Tap 独立于 Game Factory 当前生成架构。"
        ]
    },
    "game-tools": {
        "title": "开发助手与项目记录同步",
        "mode": "阶段协作流程",
        "nodes": [
            {
                "id": "message",
                "label": "开发协作消息",
                "sub": "任务与回复",
                "kind": "entry",
                "detail": "由明确消息入口发起开发协作。",
                "x": 38,
                "y": 65
            },
            {
                "id": "assistant",
                "label": "开发助手",
                "sub": "任务处理 · 回复链路",
                "kind": "compute",
                "detail": "连接消息与开发环境，维护回复可达性。",
                "x": 350,
                "y": 65
            },
            {
                "id": "project",
                "label": "项目与任务记录",
                "sub": "交付上下文",
                "kind": "data",
                "detail": "保存项目、任务及对应工作进展。",
                "x": 662,
                "y": 65
            },
            {
                "id": "reports",
                "label": "日报 / 周报关联",
                "sub": "多层工作记录",
                "kind": "compute",
                "detail": "把任务与周期汇报关联。",
                "x": 38,
                "y": 235
            },
            {
                "id": "reconcile",
                "label": "记录核对与修复",
                "sub": "自动化总账",
                "kind": "control",
                "detail": "核对同步和关联，发现缺失后修复。",
                "x": 350,
                "y": 235
            },
            {
                "id": "sync",
                "label": "协作平台同步",
                "sub": "工作进展",
                "kind": "entry",
                "detail": "维护开发记录与任务状态，由研发人员核对结果并推进交付。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "message",
                "to": "assistant",
                "label": ""
            },
            {
                "from": "assistant",
                "to": "project",
                "label": ""
            },
            {
                "from": "project",
                "to": "reports",
                "label": ""
            },
            {
                "from": "reports",
                "to": "reconcile",
                "label": ""
            },
            {
                "from": "reconcile",
                "to": "sync",
                "label": ""
            }
        ],
        "notes": [
            "游戏运行流程与开发协作流程分别组织。"
        ]
    },
    "screen": {
        "title": "轻量静态展示结构",
        "mode": "前端结构图",
        "nodes": [
            {
                "id": "content",
                "label": "展示内容",
                "sub": "团队与成果资料",
                "kind": "data",
                "detail": "静态站点的展示内容。",
                "x": 38,
                "y": 65
            },
            {
                "id": "html",
                "label": "静态 HTML 页面",
                "sub": "版面与交互",
                "kind": "compute",
                "detail": "页面实现与内容展示。",
                "x": 350,
                "y": 65
            },
            {
                "id": "assets",
                "label": "本地素材与 Vendor",
                "sub": "图像 · 前端依赖",
                "kind": "data",
                "detail": "已存在的素材与依赖资源。",
                "x": 662,
                "y": 65
            },
            {
                "id": "serve",
                "label": "静态服务入口",
                "sub": "路径与资源完整性",
                "kind": "external",
                "detail": "通过静态服务访问页面。",
                "x": 38,
                "y": 235
            },
            {
                "id": "browser",
                "label": "浏览器展示",
                "sub": "大屏呈现",
                "kind": "entry",
                "detail": "读者看到的展示界面。",
                "x": 350,
                "y": 235
            },
            {
                "id": "review",
                "label": "视觉与资源检查",
                "sub": "评审阶段",
                "kind": "control",
                "detail": "核对页面与资源，正式部署证据独立确认。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "content",
                "to": "html",
                "label": ""
            },
            {
                "from": "html",
                "to": "assets",
                "label": ""
            },
            {
                "from": "assets",
                "to": "serve",
                "label": ""
            },
            {
                "from": "serve",
                "to": "browser",
                "label": ""
            },
            {
                "from": "browser",
                "to": "review",
                "label": ""
            }
        ],
        "notes": [
            "为已有静态版本结构，不表示正式上线验收。"
        ]
    },
    "youkeai": {
        "title": "多角色内容与激励任务协同",
        "mode": "业务模块关系图",
        "nodes": [
            {
                "id": "kol",
                "label": "KOL",
                "sub": "内容与任务参与",
                "kind": "entry",
                "detail": "KOL 侧参与平台流程。",
                "x": 38,
                "y": 65
            },
            {
                "id": "mcn",
                "label": "MCN",
                "sub": "机构协作",
                "kind": "entry",
                "detail": "机构角色通过对应权限参与。",
                "x": 350,
                "y": 65
            },
            {
                "id": "operator",
                "label": "运营与平台角色",
                "sub": "任务管理",
                "kind": "entry",
                "detail": "负责内容与激励任务管理。",
                "x": 662,
                "y": 65
            },
            {
                "id": "identity",
                "label": "角色与权限",
                "sub": "访问控制",
                "kind": "control",
                "detail": "按角色管理数据和流程权限。",
                "x": 38,
                "y": 235
            },
            {
                "id": "content",
                "label": "达人与内容模块",
                "sub": "KOL · 内容",
                "kind": "compute",
                "detail": "管理达人与内容维度业务。",
                "x": 350,
                "y": 235
            },
            {
                "id": "tasks",
                "label": "激励任务模块",
                "sub": "任务 · 流程",
                "kind": "compute",
                "detail": "管理激励任务生命周期与业务流程。",
                "x": 662,
                "y": 235
            },
            {
                "id": "organization",
                "label": "MCN 模块",
                "sub": "机构关联",
                "kind": "compute",
                "detail": "组织机构关系与对应业务。",
                "x": 38,
                "y": 405
            },
            {
                "id": "workflow",
                "label": "任务 / 内容全流程",
                "sub": "状态管理",
                "kind": "data",
                "detail": "任务维度与内容维度共同支撑全流程管理。",
                "x": 350,
                "y": 405
            },
            {
                "id": "clients",
                "label": "多端业务入口",
                "sub": "平台使用",
                "kind": "entry",
                "detail": "后端能力服务多个角色和终端。",
                "x": 662,
                "y": 405
            }
        ],
        "layers": [
            {
                "label": "平台角色",
                "y": 30
            },
            {
                "label": "后端业务模块",
                "y": 200
            },
            {
                "label": "协作与流程",
                "y": 370
            }
        ],
        "height": 580,
        "edges": [
            {
                "from": "kol",
                "to": "identity",
                "label": "权限",
                "kind": "control"
            },
            {
                "from": "mcn",
                "to": "identity",
                "label": "权限",
                "kind": "control"
            },
            {
                "from": "operator",
                "to": "identity",
                "label": "权限",
                "kind": "control"
            },
            {
                "from": "identity",
                "to": "content",
                "label": "授权",
                "kind": "control"
            },
            {
                "from": "identity",
                "to": "tasks",
                "label": "授权",
                "kind": "control"
            },
            {
                "from": "mcn",
                "to": "organization",
                "label": "机构"
            },
            {
                "from": "content",
                "to": "workflow",
                "label": "内容流程"
            },
            {
                "from": "tasks",
                "to": "workflow",
                "label": "任务流程"
            },
            {
                "from": "organization",
                "to": "workflow",
                "label": "关系"
            },
            {
                "from": "workflow",
                "to": "clients",
                "label": "服务"
            }
        ],
        "notes": [
            "图示呈现多端业务模块间的职责关系。"
        ]
    },
    "driving": {
        "title": "感知环境到候选轨迹评估",
        "mode": "参与模块逻辑架构",
        "nodes": [
            {
                "id": "input",
                "label": "HD 地图与感知数据",
                "sub": "LIDAR · 摄像头 · 雷达",
                "kind": "entry",
                "detail": "将道路和感知信息作为规划输入。",
                "x": 38,
                "y": 65
            },
            {
                "id": "state",
                "label": "车辆与环境特征",
                "sub": "状态定义",
                "kind": "data",
                "detail": "定义车辆状态、道路与环境特征。",
                "x": 350,
                "y": 65
            },
            {
                "id": "behavior",
                "label": "行为决策与规则状态机",
                "sub": "转弯 · 变道 · 路口",
                "kind": "compute",
                "detail": "本人参与实现具体场景规则和行为决策。",
                "x": 662,
                "y": 65
            },
            {
                "id": "candidate",
                "label": "可行路径候选",
                "sub": "A* · 采样优化",
                "kind": "compute",
                "detail": "按规则与道路约束生成候选。",
                "x": 38,
                "y": 235
            },
            {
                "id": "trajectory",
                "label": "轨迹优化与代价评估",
                "sub": "成本函数 · 排序",
                "kind": "compute",
                "detail": "比较候选轨迹，评估可行性。",
                "x": 350,
                "y": 235
            },
            {
                "id": "output",
                "label": "规划模块输出",
                "sub": "候选路径",
                "kind": "entry",
                "detail": "验证行为与路径规划模块在交叉路口、环岛及车道变换等场景中的表现。",
                "x": 662,
                "y": 235
            }
        ],
        "layers": [
            {
                "label": "输入与约束",
                "y": 30
            },
            {
                "label": "处理与验证",
                "y": 200
            }
        ],
        "height": 410,
        "edges": [
            {
                "from": "input",
                "to": "state",
                "label": ""
            },
            {
                "from": "state",
                "to": "behavior",
                "label": ""
            },
            {
                "from": "behavior",
                "to": "candidate",
                "label": ""
            },
            {
                "from": "candidate",
                "to": "trajectory",
                "label": ""
            },
            {
                "from": "trajectory",
                "to": "output",
                "label": ""
            }
        ],
        "notes": [
            "图示呈现规划模块间的职责与协作关系。"
        ]
    }
};
